export default __webpack_public_path__ + "static/media/clicked-blue.f6a7719b.svg";